import { render, staticRenderFns } from "./SincronizacaoManual.vue?vue&type=template&id=12fd8192&scoped=true&"
import script from "./SincronizacaoManual.vue?vue&type=script&lang=js&"
export * from "./SincronizacaoManual.vue?vue&type=script&lang=js&"
import style0 from "./SincronizacaoManual.vue?vue&type=style&index=0&id=12fd8192&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd8192",
  null
  
)

export default component.exports